import { COMPANY } from "@/data";

/**
 * The fixed logo SVGs (extracted from the original PDF) contain the full
 * Huron Truss lockup — icon + HURON TRUSS wordmark — filling a 1:1 viewBox
 * with virtually no padding. Use this component everywhere the logo appears.
 *
 * Aspect ratio: 1:1. Just set the height; width is derived.
 */
export default function Logo({
  variant = "dark",
  height = 56,
  className = "",
  ...rest
}) {
  const src = variant === "light" ? COMPANY.logoLight : COMPANY.logoDark;
  return (
    <img
      src={src}
      alt="Huron Truss Ltd."
      draggable={false}
      style={{ height, width: "auto" }}
      className={`block ${className}`}
      {...rest}
    />
  );
}
